import React from 'react';
import ReactDOM from 'react-dom/client';
import {
  createBrowserRouter,
  RouterProvider,
} from "react-router-dom";
import { UserProvider } from './context/userContext';
import './index.css';
import Home from './routes/home.route';
import SigninPage from './routes/signin.route';
import SignupPage from './routes/signup.route';
import DashboardPage from './routes/dashboard.route';
import About from './routes/about.route';
import Support from './routes/contact.route';
import ErrorPage from './error-page';
import reportWebVitals from './reportWebVitals';
import ScrollToTop from './scrollToTop';
import PrivacyPolicy from './routes/privacypolicy.route';
import Terms from './routes/terms.route';
import RefundPolicy from './routes/refundpolicy.route';
import VCard from './routes/vcard.route';

const router = createBrowserRouter([
  {
    path: "/",
    element: <Home/>,
    errorElement: <ErrorPage />,
  },
  {
    path: "/about",
    element: <About/>,
  },
  {
    path: "/support",
    element: <Support/>,
  },
  {
    path: "/signin",
    element: <SigninPage/>,
  },
  {
    path: "/signup",
    element: <SignupPage/>,
  },
  {
    path: "/dashboard",
    element: <DashboardPage/>,
  },
  {
    path: "/termsofservice",
    element: <Terms/>,
  },
  {
    path: "/privacypolicy",
    element: <PrivacyPolicy/>,
  },
  {
    path: "/refundpolicy",
    element: <RefundPolicy/>,
  },
  {
    path: "/vcard",
    element: <VCard/>,
  },
  
]);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ScrollToTop/>
    <UserProvider>
      <RouterProvider router={router} />
    </UserProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
